/* eslint import/no-extraneous-dependencies: 0 */
import * as Blockly from 'blockly';

// Muestra en el bloque el `alt` de la opción como texto y deja las imágenes solo para el menú,
// como en prod (FieldDropdown dibujaría la imagen sobre el bloque).

export class IconDropdown extends Blockly.FieldDropdown {
  renderSelectedImage() {
    this.renderSelectedText();
  }
}

export default IconDropdown;
